import { render, staticRenderFns } from "./CashbackEcomSingle.vue?vue&type=template&id=43966b98&"
import script from "./CashbackEcomSingle.vue?vue&type=script&lang=ts&"
export * from "./CashbackEcomSingle.vue?vue&type=script&lang=ts&"
import style0 from "./CashbackEcomSingle.vue?vue&type=style&index=0&id=43966b98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports